import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rp-home-menu-burger',
  standalone: true,
  templateUrl: './menu-burger.component.html',
  styleUrl: './menu-burger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuBurgerComponent {}
